import { BREAKPOINT, MARGIN, PADDING, REBRAND_COLOR } from '@latitude/core/utils/constants';
import styled from 'styled-components';
import Section from '@latitude/section-rebrand';

export const RewardsWrapper = styled(Section)`
  width: 100%;
  background: ${REBRAND_COLOR.WHITE};
  padding-top: ${PADDING.P32};
  padding-bottom: ${PADDING.P32};
  @media (min-width: ${BREAKPOINT.MD}) {
    padding-top: ${PADDING.P64};
    padding-bottom: ${PADDING.P64};
  }
  a {
    text-underline-offset: 3px; 
  }
`;

export const RewardsTextWrapper = styled.div`
  width: 100%;
  background: ${REBRAND_COLOR.WHITE};
  padding-bottom: 0;
  text-align: start;
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media (min-width: ${BREAKPOINT.MD}) {
    text-align: center;
  }
`;

export const CtaBottomWrapper = styled.div`
  width: 100%;
  background: ${REBRAND_COLOR.WHITE};
  padding-top: 0;
`;

export const StyledCardSection = styled.div`
  padding: 0;
  .container {
    padding: 0;
  }

  @media (min-width: ${BREAKPOINT.MD}) {
    .container {
      padding: initial;
    }
  }
`;

export const CardContainer = styled.div`
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x mandatory;
  scroll-padding: 16px;
  gap: 16px;
  width: 100%;
  margin-top: ${MARGIN.M24};
  background: ${REBRAND_COLOR.WHITE};
  padding: 0;
  scrollbar-width: none;

  /* hide scrollbar where possible */
  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: ${BREAKPOINT.MD}) {
    display: grid;
    grid-template-columns: repeat(
      ${({ length }) => (length && length > 4 ? 4 : length)},
      1fr
    );
    grid-template-rows: 1fr;
    gap: 20px;
  }
`;

export const Card = styled.div`
  scroll-snap-align: start;
  display: flex;
  flex-direction: column;

  min-width: 82vw;
  max-width: 420px;

  border: 1px solid ${REBRAND_COLOR.BLACK_40};
  border-radius: 16px;
  overflow: hidden;
  background: ${REBRAND_COLOR.WHITE};
  align-items: stretch;
  height: auto;
  margin-bottom: 5px;

  @media (min-width: ${BREAKPOINT.MD}) {
    min-width: unset;
    max-width: unset;
  }
`;

export const CardImage = styled.img`
  width: 100%;
  object-fit: cover;
`;

export const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding: ${PADDING.P24};
`;

export const CardContent = styled.div`
  flex: 1 1 auto;
  overflow: visible;
`;

export const StyledCardButtonWrapper = styled.div`
  margin-top: auto;
  display: flex;
  align-items: flex-start;
`;

export const RewardsCtaWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  margin-top: ${MARGIN.M24};

  @media (min-width: ${BREAKPOINT.MD}) {
    justify-content: center;
  }
`;

export const StyledCardHeading = styled.div`
  margin-bottom: ${MARGIN.M16};
`

export const DescriptionWrapper = styled.div`
  width: 100%;
  text-align: center;
  margin-top: ${MARGIN.M16};
  padding: 0 ${PADDING.P24};
  color: ${REBRAND_COLOR.BLACK_80};
`;

